export default __webpack_public_path__ + "static/media/android-icon-192x192.f5e18239.png";